module.exports = __webpack_public_path__ + "static/media/logoJokko.1ddf8756.png";